"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4136],{

/***/ 16154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Badge_Badge; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(13102);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/components/Badge/Badge.views.tsx

var Badge = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "egv2u7c0"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.typography.textRegularSmall;
}, ";display:inline-block;width:max-content;border-radius:5px;padding:5px 8px 4px;border:1px solid;text-decoration:none;color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";background-color:", function (_ref3) {
  var backgroundColor = _ref3.backgroundColor;
  return backgroundColor;
}, ";border-color:", function (_ref4) {
  var borderColor = _ref4.borderColor;
  return borderColor;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Badge/Badge.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var BaseBadge = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      children = _ref.children,
      tag = _ref.tag,
      className = _ref.className,
      href = _ref.href;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge, _objectSpread(_objectSpread({
    ref: ref,
    as: href ? "a" : tag || "span",
    className: className,
    href: href
  }, tokens), {}, {
    children: children
  }));
});
var Badge_Badge = (0,useDesignTokens/* withDesignTokens */.Y)(BaseBadge, function () {
  return {};
}, {
  light: function light(theme, props) {
    switch (props.variant) {
      case "filledBoysenberry":
        return {
          backgroundColor: theme.palette.brand.boysenberry[500],
          borderColor: "transparent",
          color: theme.palette.neutrals.white[100]
        };

      case "filledAcai":
        return {
          backgroundColor: theme.palette.brand.darkAcai[200],
          borderColor: "transparent",
          color: theme.palette.brand.darkAcai[500]
        };

      case "filledGreen":
        return {
          backgroundColor: theme.palette.brand.segmentGreen[100],
          borderColor: "transparent",
          color: theme.palette.brand.segmentGreen[500]
        };

      case "filledBlue":
        return {
          backgroundColor: theme.palette.twilio.blue[10],
          borderColor: "transparent",
          color: theme.palette.twilio.blue[60]
        };

      default:
        return {
          backgroundColor: "transparent",
          borderColor: theme.palette.brand.darkAcai[400],
          color: theme.palette.brand.darkAcai[500]
        };
    }
  },
  dark: function dark(theme, props) {
    switch (props.variant) {
      case "filledBoysenberry":
        return {
          backgroundColor: theme.palette.brand.boysenberry[500],
          borderColor: "transparent",
          color: theme.palette.neutrals.white[100]
        };

      case "filledAcai":
        return {
          backgroundColor: (0,polished_esm/* transparentize */.DZ)(0.9, theme.palette.neutrals.white[100]),
          borderColor: "transparent",
          color: theme.palette.neutrals.white[100]
        };

      case "filledGreen":
        return {
          backgroundColor: theme.palette.brand.segmentGreen[100],
          borderColor: "transparent",
          color: theme.palette.brand.segmentGreen[500]
        };

      case "filledBlue":
        return {
          backgroundColor: theme.palette.twilio.blue[10],
          borderColor: "transparent",
          color: theme.palette.twilio.blue[60]
        };

      default:
        return {
          color: theme.palette.neutrals.white[100],
          backgroundColor: "transparent",
          borderColor: theme.palette.neutrals.white[100]
        };
    }
  },
  twilioLight: function twilioLight(theme, props) {
    switch (props.variant) {
      case "filledBoysenberry":
        return {
          backgroundColor: theme.palette.twilio.boysenberry[60],
          borderColor: "transparent",
          color: theme.palette.neutrals.white[100]
        };

      case "filledAcai":
        return {
          backgroundColor: (0,polished_esm/* transparentize */.DZ)(0.9, theme.palette.neutrals.white[100]),
          borderColor: "transparent",
          color: theme.palette.neutrals.white[100]
        };

      case "filledGreen":
        return {
          backgroundColor: theme.palette.twilio.green[10],
          borderColor: "transparent",
          color: theme.palette.twilio.green[70]
        };

      case "filledBlue":
        return {
          backgroundColor: theme.palette.twilio.blue[10],
          borderColor: "transparent",
          color: theme.palette.twilio.blue[60]
        };

      default:
        return {
          color: theme.palette.twilio.gray[80],
          backgroundColor: "transparent",
          borderColor: theme.palette.twilio.gray[30]
        };
    }
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/components/Badge/index.ts


/***/ }),

/***/ 94136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ct": function() { return /* reexport */ Badge; },
  "MF": function() { return /* reexport */ BadgeWrapper; },
  "dk": function() { return /* reexport */ CopyText_Description; },
  "X6": function() { return /* reexport */ Heading; },
  "rU": function() { return /* reexport */ Link; },
  "Lh": function() { return /* reexport */ CopyText_Overline; },
  "ZP": function() { return /* reexport */ CopyText; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/components/Badge/index.ts + 2 modules
var components_Badge = __webpack_require__(16154);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/CopyText/CopyText.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}




var gap =  true ? {
  name: "qio5qo",
  styles: "margin:16px 0;text-align:inherit"
} : 0;
var Overline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1h0dsg16"
} : 0)(gap, " color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";" + ( true ? "" : 0));
var CopyText_views_Heading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1h0dsg15"
} : 0)(gap, ";" + ( true ? "" : 0));
var Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1h0dsg14"
} : 0)(gap, " color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";" + ( true ? "" : 0));
var LinkInner = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e1h0dsg13"
} : 0)( true ? {
  name: "1dtfkf",
  styles: "margin:0;padding-top:0"
} : 0);
var LinkOuter = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1h0dsg12"
} : 0)( true ? {
  name: "456bw7",
  styles: "margin:24px 0"
} : 0);
var CopyText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1h0dsg11"
} : 0)("text-align:start;direction:ltr;>*:first-child{margin-top:0;}>*:last-child{margin-bottom:0;}", function (_ref3) {
  var centered = _ref3.centered;
  return centered &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("text-align:center;", BadgeWrapper, "{justify-content:center;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));
var BadgeWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1h0dsg10"
} : 0)(gap, " display:flex;gap:4px;" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/CopyText/CopyText.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}








var BaseOverline = function BaseOverline(_ref) {
  var tokens = _ref.tokens,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "overline" : _ref$variant,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? "p" : _ref$tag,
      children = _ref.children,
      externalAppearance = _ref.appearance,
      className = _ref.className;
  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Overline, _objectSpread(_objectSpread({}, tokens), {}, {
    variant: variant,
    tag: tag,
    appearance: appearance,
    className: className,
    children: children
  }));
};

var CopyText_Overline = (0,useDesignTokens/* withDesignTokens */.Y)(BaseOverline, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.boysenberry[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.segmentGreen[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.green[60]
    };
  },
  twilioDark: function twilioDark(theme) {
    // eslint-disable-next-line no-warning-comments
    // TODO: Replace with twilioDark color
    return {
      color: theme.palette.twilio.green[60]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      color: theme.palette.cdpWeek2023.mint[100]
    };
  }
});
var Heading = function Heading(_ref2) {
  var _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? "h2" : _ref2$variant,
      _ref2$tag = _ref2.tag,
      tag = _ref2$tag === void 0 ? "h3" : _ref2$tag,
      children = _ref2.children,
      externalAppearance = _ref2.appearance,
      className = _ref2.className,
      dangerouslySetInnerHTML = _ref2.dangerouslySetInnerHTML;
  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText_views_Heading, {
    variant: variant,
    tag: tag,
    appearance: appearance,
    className: className,
    dangerouslySetInnerHTML: dangerouslySetInnerHTML,
    children: children
  });
};

var BaseDescription = function BaseDescription(_ref3) {
  var tokens = _ref3.tokens,
      _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? "pMedium" : _ref3$variant,
      _ref3$tag = _ref3.tag,
      tag = _ref3$tag === void 0 ? "h3" : _ref3$tag,
      children = _ref3.children,
      externalAppearance = _ref3.appearance,
      className = _ref3.className,
      dangerouslySetInnerHTML = _ref3.dangerouslySetInnerHTML;
  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, _objectSpread(_objectSpread({}, tokens), {}, {
    variant: variant,
    tag: tag,
    appearance: appearance,
    className: className,
    dangerouslySetInnerHTML: dangerouslySetInnerHTML,
    children: children
  }));
};

var CopyText_Description = (0,useDesignTokens/* withDesignTokens */.Y)(BaseDescription, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      color: theme.palette.neutrals.white[100]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      color: theme.palette.twilio.gray[10]
    };
  }
});
var Link = function Link(_ref4) {
  var href = _ref4.href,
      target = _ref4.target,
      color = _ref4.color,
      _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? "medium" : _ref4$size,
      children = _ref4.children,
      appearance = _ref4.appearance,
      className = _ref4.className;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkOuter, {
    className: className,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkInner, {
      color: color,
      appearance: appearance,
      size: size,
      tag: "a",
      href: href,
      target: target,
      iconEnd: Common/* ChevronRightIcon */.XC,
      children: children
    })
  });
};
var Badge = function Badge(_ref5) {
  var _ref5$variant = _ref5.variant,
      variant = _ref5$variant === void 0 ? "filledBlue" : _ref5$variant,
      children = _ref5.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Badge/* default */.Z, {
    variant: variant,
    children: children
  });
};
;// CONCATENATED MODULE: ../../libs/matcha/recipes/CopyText/index.ts


CopyText.displayName = "CopyTextBase";
CopyText_Overline.displayName = "CopyText.Overline";
Heading.displayName = "CopyText.Heading";
CopyText_Description.displayName = "CopyText.Description";
Link.displayName = "CopyText.Link";
Badge.displayName = "CopyText.Badge";
BadgeWrapper.displayName = "CopyText.BadgeWrapper";


/***/ })

}]);